"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAD_REQUEST = exports.OK = void 0;
exports.OK = 200;
exports.BAD_REQUEST = 400;
